<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="会员列表" name="first">
        <!--        <div>-->
        <!--          <div class="title_div">-->
        <!--            <span class="title-span">门店:</span>-->
        <!--            <el-select clearable  size="small" class="title-select"></el-select>-->
        <!--            <span class="title-span">会员等级:</span>-->
        <!--            <el-select clearable  size="small" class="title-select"></el-select>-->
        <!--            <span class="title-span">归属:</span>-->
        <!--            <el-select clearable  size="small" class="title-select"></el-select>-->
        <!--            <span class="title-span">开卡时间:</span>-->
        <!--            <el-date-picker-->
        <!--              v-model="hyStartDate"-->
        <!--              size="small"-->
        <!--              class="title-date1"-->
        <!--              type="date"-->
        <!--              placeholder="选择开始日期">-->
        <!--            </el-date-picker>-->
        <!--            至-->
        <!--            <el-date-picker-->
        <!--              v-model="hyEndDate"-->
        <!--              size="small"-->
        <!--              class="title-date2"-->
        <!--              type="date"-->
        <!--              placeholder="选择结束日期">-->
        <!--            </el-date-picker>-->
        <!--          </div>-->
        <!--          <div style="text-align: right">-->
        <!--            <el-button class="creat-button" type="primary" size="small">新建会员</el-button>-->
        <!--            <el-button class="out-button" type="primary" size="small">批量导出</el-button>-->
        <!--          </div>-->
        <!--          <div class="mm-tb">-->
        <!--            <el-table-->
        <!--              :data="hyTableData"-->
        <!--              style="width: 100%">-->
        <!--              <el-table-column-->
        <!--                prop="date"-->
        <!--                label="序号"-->
        <!--                align="center"-->
        <!--                width="80">-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="name"-->
        <!--                label="会员姓名"-->
        <!--                align="center"-->
        <!--                width="160">-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="address"-->
        <!--                label="手机号码"-->
        <!--                align="center"-->
        <!--                width="200"-->
        <!--              >-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="address"-->
        <!--                label="会员等级"-->
        <!--                align="center"-->
        <!--                width="160"-->
        <!--              >-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="address"-->
        <!--                label="会员积分"-->
        <!--                align="center"-->
        <!--                width="160"-->
        <!--              >-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="address"-->
        <!--                label="门店"-->
        <!--                align="center"-->
        <!--                width="250"-->
        <!--              >-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="address"-->
        <!--                label="归属人"-->
        <!--                align="center"-->
        <!--                width="160"-->
        <!--              >-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="address"-->
        <!--                label="开卡日期"-->
        <!--                align="center"-->
        <!--                width="200"-->
        <!--              >-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="address"-->
        <!--                align="center"-->
        <!--                label="操作">-->
        <!--              </el-table-column>-->
        <!--            </el-table>-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <el-pagination-->
        <!--              class="mm-page"-->
        <!--              @size-change="handleSizeChange"-->
        <!--              @current-change="handleCurrentChange"-->
        <!--              :current-page="hyCurrentPage"-->
        <!--              :page-size="100"-->
        <!--              layout="total,prev, pager, next, jumper"-->
        <!--              :total="1000">-->
        <!--            </el-pagination>-->
        <!--          </div>-->
        <!--        </div>-->
      </el-tab-pane>
      <el-tab-pane label="会员营销" name="second">
        <div>
          <div class="title_div">
            <span class="title-span">门店:</span>
            <el-select
            filterable 
              clearable
              v-model="hyParams.shopId"
              size="small"
              class="title-select"
              @change="mdStortChange"
            >
              <el-option
                v-for="item in this.mdSelectList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
            <span class="title-span">会员等级:</span>
            <el-select
              clearable
              v-model="hyParams.levelId"
              size="small"
              class="title-select"
              @change="djStortChange"
            >
              <el-option
                v-for="item in this.djSelectList"
                :label="item.cardName"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>

            <span class="title-span">归属:</span>
            <el-select
              clearable
              v-model="hyParams.userId"
              size="small"
              class="title-select"
              filterable
              remote
              :loading="loading"
              :remote-method="remoteMethod"
              @change="dyStortChange"
            >
              <el-option
                v-for="item in this.jlSelectList"
                :label="item.realname"
                :value="item.userId"
                :key="item.userId"
              ></el-option>
            </el-select>
            <br />
            <span class="title-span">开卡时间:</span>
            <el-date-picker
              @change="hyStartChange"
              v-model="hyParams.createDateStart"
              size="small"
              class="title-date1"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
            至
            <el-date-picker
              @change="hyEndChange"
              v-model="hyParams.createDateEnd"
              size="small"
              class="title-date2"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
            >
            </el-date-picker>
            <span class="title-span">会员:</span>
            <el-input
              size="small"
              style="width: 200px; margin-left: 20px; margin-top: 20px"
              v-model="hyParams.queryValue"
              placeholder="请输入会员电话或姓名"
              clearable
              @input="hyMemberInfo"
            ></el-input>
          </div>
          <!--          <div style="text-align: right">-->
          <!--            <el-button class="creat-button" type="primary" size="small">新建会员</el-button>-->
          <!--            <el-button class="out-button" type="primary" size="small">批量导出</el-button>-->
          <!--          </div>-->
          <div class="mm-tb">
            <el-table :data="hyList" style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column
                prop="antMemberName"
                label="会员姓名"
                align="center"
                width="120"
              >
              </el-table-column>
              <el-table-column
                prop="memberMobile"
                align="center"
                label="手机号码"
              >
              </el-table-column>
              <el-table-column prop="levelName" align="center" label="会员等级">
              </el-table-column>
              <el-table-column
                prop="lastXiaoFeidt"
                align="center"
                label="上次消费"
              >
                <!--                <template slot-scope="scope">{{scope.row.lastXiaoFeidt.substring(0,10)}}</template>-->
              </el-table-column>
              <el-table-column prop="opdt" align="center" label="消费日期">
                <template slot-scope="scope">{{
                  scope.row.opdt ? scope.row.opdt.substring(0, 10) : ""
                }}</template>
              </el-table-column>
              <el-table-column
                prop="consumptionCycle"
                align="center"
                label="消费周期"
              >
              </el-table-column>
              <el-table-column prop="rollCase" align="center" label="用票情况">
                <template slot-scope="scope">
                  {{ scope.row.rollCase }}张
                </template>
              </el-table-column>
              <el-table-column
                prop="cumulativeVolume"
                align="center"
                label="累积用票"
              >
                <template slot-scope="scope">
                  {{ scope.row.cumulativeVolume }}张
                </template>
              </el-table-column>
              <el-table-column
                prop="shiShouJinEr"
                align="center"
                label="消费金额"
              >
                <template slot-scope="scope">
                  {{ scope.row.shiShouJinEr }}元
                </template>
              </el-table-column>
              <el-table-column
                prop="historyAmountCount"
                align="center"
                label="累积消费次数"
              >
                <template slot-scope="scope">
                  {{ scope.row.historyAmountCount }}次
                </template>
              </el-table-column>
              <el-table-column
                prop="historyAmount"
                align="center"
                label="累计消费金额"
              >
                <template slot-scope="scope">
                  {{ scope.row.historyAmount }}元
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              class="mm-page"
              @size-change="hySizeChange"
              @current-change="hyCurrentChange"
              :current-page="hyResult.current"
              :page-size="hyResult.size"
              layout="total,prev, pager, next, sizes"
              :total="hyResult.total"
              :page-sizes="[10, 20, 30, 40, 50]"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="会员列表管理" name="three">
        <!--        <div>-->
        <!--          <div class="title_div">-->
        <!--            <span class="title-span">门店:</span>-->
        <!--            <el-select clearable  size="small" class="title-select"></el-select>-->
        <!--            <span class="title-span">会员等级:</span>-->
        <!--            <el-select clearable  size="small" class="title-select"></el-select>-->
        <!--            <span class="title-span">归属:</span>-->
        <!--            <el-select clearable  size="small" class="title-select"></el-select>-->
        <!--            <span class="title-span">开卡时间:</span>-->
        <!--            <el-date-picker-->
        <!--              v-model="hyParams.createDateStart"-->
        <!--              size="small"-->
        <!--              class="title-date1"-->
        <!--              type="date"-->
        <!--              placeholder="选择开始日期">-->
        <!--            </el-date-picker>-->
        <!--            至-->
        <!--            <el-date-picker-->
        <!--              v-model="hyParams.createDateEnd"-->
        <!--              size="small"-->
        <!--              class="title-date2"-->
        <!--              type="date"-->
        <!--              placeholder="选择结束日期">-->
        <!--            </el-date-picker>-->
        <!--          </div>-->
        <!--          <div style="text-align: right">-->
        <!--            <el-button class="creat-button" type="primary" size="small" @click="creatVip">新建会员</el-button>-->
        <!--            <el-button class="out-button" type="primary" size="small">批量导出</el-button>-->
        <!--          </div>-->
        <!--          <div class="mm-tb">-->
        <!--            <el-table-->
        <!--              :data="hyList"-->
        <!--              style="width: 100%">-->
        <!--              <el-table-column-->
        <!--                prop="date"-->
        <!--                label="序号"-->
        <!--                align="center"-->
        <!--                width="80">-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="name"-->
        <!--                label="会员姓名"-->
        <!--                align="center"-->
        <!--                width="160">-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="address"-->
        <!--                label="手机号码"-->
        <!--                align="center"-->
        <!--                width="200"-->
        <!--              >-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="address"-->
        <!--                label="会员等级"-->
        <!--                align="center"-->
        <!--                width="160"-->
        <!--              >-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="address"-->
        <!--                label="会员积分"-->
        <!--                align="center"-->
        <!--                width="160"-->
        <!--              >-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="address"-->
        <!--                label="门店"-->
        <!--                align="center"-->
        <!--                width="250"-->
        <!--              >-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="address"-->
        <!--                label="归属人"-->
        <!--                align="center"-->
        <!--                width="160"-->
        <!--              >-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="address"-->
        <!--                label="开卡日期"-->
        <!--                align="center"-->
        <!--                width="200"-->
        <!--              >-->
        <!--              </el-table-column>-->
        <!--              <el-table-column-->
        <!--                prop="address"-->
        <!--                align="center"-->
        <!--                label="操作">-->
        <!--              </el-table-column>-->
        <!--            </el-table>-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <el-pagination-->
        <!--              class="mm-page"-->
        <!--              @size-change="hySizeChange"-->
        <!--              @current-change="hyCurrentChange"-->
        <!--              :current-page="hyResult.pageNo"-->
        <!--              :page-size="hyResult.pageSize"-->
        <!--              layout="total,prev, pager, next, jumper"-->
        <!--              :total="hyResult.total">-->
        <!--            </el-pagination>-->
        <!--          </div>-->
        <!--        </div>-->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  getAddPriceAccPage,
  getUserForSelect,
  addAntMembers,
  getAntMembersForExcel,
  getCoachListForSelect,
} from "../../api/MemberManagement";
import {
  getAntDeptSelect,
  getMembersCardLevelSelect,
  getHonourList,
  addUser,
} from "../../api/BusinessManagement";

export default {
  name: "MemberManage",
  data() {
    return {
      activeName: "second",
      hyParams: {
        createDateStart: "",
        createDateEnd: "",
        shopId: "",
        levelId: "",
        userId: "",
        pageNo: 1,
        pageSize: 10,
        queryValue: "",
      },
      hyResult: {},
      hyList: [],
      mdSelectList: [],
      jlSelectList: [],
      djSelectList: [],
      loading: false,
    };
  },
  mounted() {
    this.getAddPriceAccPage(this.hyParams);
    this.getAntDeptSelect();
    this.getMembersCardLevelSelect();
    this.getUserByShop();
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == "会员列表") {
        this.$router.push("/MemberManagement/MemberLlist");
      } else if (tab.label == "会员营销") {
      } else if (tab.label == "会员列表管理") {
        this.$router.push("/MemberManagement/MemberLlistManagement");
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          getCoachListForSelect({ queryValue: query }).then((res) => {
            if (res.status === 200 && res.data.success) {
              this.jlSelectList = res.data.result;
            }
          });
        }, 200);
      } else {
        this.jlSelectList = [];
      }
    },
    //获取会员列表
    getAddPriceAccPage(params) {
      getAddPriceAccPage(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.hyResult = res.data.result;
            this.hyList = res.data.result.records;
          } else {
            this.hyResult = res.data.result;
            this.hyList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    hySizeChange(newSize) {
      this.hyParams.pageSize = newSize;
      this.getAddPriceAccPage(this.hyParams);
    },
    hyCurrentChange(newPage) {
      this.hyParams.pageNo = newPage;
      this.getAddPriceAccPage(this.hyParams);
    },
    //获取门店下拉菜单
    getAntDeptSelect() {
      getAntDeptSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.mdSelectList = res.data.result;
          }
        }
      });
    },
    // 会员模糊搜索
    hyMemberInfo() {
       this.hyParams.pageNo = 1;
      this.getAddPriceAccPage(this.hyParams);
    },
    //门店下拉菜单改变
    mdStortChange(val) {
      this.hyParams.pageNo = 1;
      this.getAddPriceAccPage(this.hyParams);
      // this.getUserByShop(val);
    },
    //获取会员等级下拉列表
    getMembersCardLevelSelect() {
      getMembersCardLevelSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.djSelectList = res.data.result;
          }
        }
      });
    },
    //会员等级下拉菜单改变
    djStortChange(val) {
       this.hyParams.pageNo = 1;
      this.getAddPriceAccPage(this.hyParams);
    },
    //店员筛选下拉
    dyStortChange(val) {
      if (val === "") {
        this.getUserByShop();
      }
      this.hyParams.pageNo = 1;
      this.getAddPriceAccPage(this.hyParams);
    },
    //店员下拉
    getUserByShop(shopId) {
      // getUserForSelect({ shopId: shopId }).then((res) => {
      getUserForSelect({ queryAll: 1 }).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.jlSelectList = res.data.result;
          }
        }
      });
    },
    //会员开始时间改变
    hyStartChange() {
      if (
        this.hyParams.createDateStart &&
        this.hyParams.createDateEnd &&
        new Date(this.hyParams.createDateStart).getTime() >
          new Date(this.hyParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.hyParams.pageNo = 1;
      this.getAddPriceAccPage(this.hyParams);
    },
    //会员结束时间改变
    hyEndChange() {
      if (
        this.hyParams.createDateStart &&
        this.hyParams.createDateEnd &&
        new Date(this.hyParams.createDateStart).getTime() >
          new Date(this.hyParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.hyParams.pageNo = 1;
      this.getAddPriceAccPage(this.hyParams);
    },
  },
};
</script>

<style scoped>
.title-span {
  font-size: 16px;
}

.title_div {
  margin: 20px 30px;
}

.title-select {
  margin: 0 20px;
}

.title-date1 {
  margin-left: 20px;
  width: 180px;
}

.title-date2 {
  width: 180px;
  margin-right: 20px;
}

.creat-button {
  margin: 20px;
}

.out-button {
  margin-top: 20px;
  margin-right: 80px;
  margin-bottom: 20px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}
.orderMain {
  padding: 30px;
}
</style>
